<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div
        class="card bg-secondary shadow border-0 vld-parent"
        ref="formContainer"
      >
        <div class="card-header bg-transparent pb-4 pt-4">
          <img
            class="mx-auto d-block img-fluid"
            width="30%"
            :src="defaultLogo"
          />
        </div>
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4">
            <small>Entre com suas credenciais</small>
          </div>
          <form role="form" @submit="handleSignIn">
            <base-input
              class="input-group-alternative mb-3"
              placeholder="Email"
              addon-left-icon="ni ni-email-83"
              v-model="model.email"
            >
            </base-input>

            <base-input
              class="input-group-alternative"
              placeholder="Senha"
              :type="passwordVisible ? 'input' : 'password'"
              addon-left-icon="ni ni-lock-circle-open"
              v-model="model.password"
            >
            </base-input>

            <base-checkbox
              v-model="passwordVisible"
              class="custom-control-alternative text-right mr-1"
            >
              <span class="text-muted ml--3">Visualizar senha</span>
            </base-checkbox>
            <base-alert type="danger" class="text-center mt-4 mb-0" v-if="error"
              ><i class="fas fa-exclamation-circle mr-1"></i>
              {{ error }}</base-alert
            >

            <div class="text-center">
              <base-button
                nativeType="submit"
                class="mt-4 px-5"
                type="default"
                title="Entrar no portal"
                >Entrar</base-button
              >
            </div>
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <router-link to="/forgot-password" class="text-light float-right"
            ><small>Esqueceu sua senha?</small></router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../services/api";
import { login } from "../services/auth";

export default {
  name: "login",
  data() {
    return {
      model: {
        email: "",
        password: ""
      },
      passwordVisible: false,
      error: ""
    };
  },
  methods: {
    async handleSignIn(e) {
      e.preventDefault();
      const user = this.model;
      user.email = user.email.trim();
      if (!user.email || !user.password) {
        this.error = "Preencha seu email e senha para continuar.";
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
          width: 128,
          height: 128
        });
        try {
          const { data } = await api.post("/sessions", user);
          login(data.auth.token, data.roles);
          const rolesMap = {
            admin: "admin",
            company: "empresa",
            collaborator: "colaborador",
            client: "cliente"
          };
          this.$router.push(`/${rolesMap[data.roles[0]]}`);
          this.$toasted.show("Bem-vindo! :)");
        } catch (e) {
          const genericError =
            "Houve um problema com o login, verifique suas credenciais.";
          const hasErrorResponseData = e.response && e.response.data;
          let customError = genericError;
          if (hasErrorResponseData) {
            customError = e.response.data.message;
          }
          this.error = hasErrorResponseData ? customError : genericError;
          this.$toasted.error("Ocorreu um erro com o login");
        } finally {
          loader.hide();
        }
      }
    }
  },
  computed: {
    defaultLogo() {
      let logoFile = "LOGO_PIC.png";
      if (window.location.host.includes("cobusiness"))
        logoFile = "cobusiness.png";
      else if (window.location.host.includes("sislimpa"))
        logoFile = "sislimpa.png";
      else if (window.location.host.includes("genius")) logoFile = "genius.png";

      return `/img/brand/${logoFile}`;
    }
  }
};
</script>
<style scoped></style>
